<p-table
  [value]="assignments"
  [scrollable]="true"
  scrollHeight="62vh"
  styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
  [tableStyle]="{ 'min-width': '1200px' }"
  [rowHover]="true"
>
  <ng-template pTemplate="header">
    <tr>
      <!-- CommPkg column -->
      @if (showColumn('cpNumber')) {
        <th class="col-cp">CommPkg</th>
      }

      <!-- MC Package column -->
      @if (showColumn('mcpNumber')) {
        <th class="col-mcp">MC Package</th>
      }

      <!-- Tag column -->
      @if (showColumn('tagNumber')) {
        <th class="col-tag">Tag</th>
      }

      <!-- Checksheet column -->
      @if (showColumn('checksheetNumber')) {
        <th class="col-cs">Checksheet</th>
      }

      <!-- Type column -->
      @if (showColumn('checksheetType')) {
        <th class="col-type">Type</th>
      }

      <!-- Status column -->
      @if (showColumn('status')) {
        <th class="col-status">Status</th>
      }

      <!-- Progress column -->
      @if (showColumn('progress')) {
        <th class="col-progress">Progress</th>
      }

      <!-- Punches column -->
      @if (showColumn('punchCount')) {
        <th class="col-punch">Punches</th>
      }

      <!-- Signed column -->
      @if (showColumn('signed')) {
        <th class="col-sig">Signed</th>
      }

      <!-- Verified column -->
      @if (showColumn('verified')) {
        <th class="col-sig">Verified</th>
      }

      <!-- Site column -->
      @if (showColumn('siteNumber')) {
        <th class="col-site">Site</th>
      }

      <!-- Company column -->
      @if (showColumn('companyNumber')) {
        <th class="col-company">Company</th>
      }

      <!-- Phase column -->
      @if (showColumn('phaseNumber')) {
        <th class="col-phase">Phase</th>
      }

      <!-- Missing column -->
      @if (showColumn('missingCertificates')) {
        <th class="col-missing">Missing</th>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-assignment>
    <tr [class.voided-row]="isVoided(assignment)">
      <!-- CommPkg -->
      @if (showColumn('cpNumber')) {
        <td class="col-cp">
          @if (assignment.cpId) {
            <button
              pButton
              [label]="assignment.cpNumber || '-'"
              [text]="true"
              size="small"
              class="nav-btn"
              (click)="navToCp(assignment)"
              [pTooltip]="'Go to ' + assignment.cpNumber"
              tooltipPosition="top"
            ></button>
          } @else {
            <span class="muted">—</span>
          }
        </td>
      }

      <!-- MC Package -->
      @if (showColumn('mcpNumber')) {
        <td class="col-mcp">
          @if (assignment.mcpId) {
            <button
              pButton
              [label]="assignment.mcpNumber || '-'"
              [text]="true"
              size="small"
              class="nav-btn"
              (click)="navToMcp(assignment)"
              [pTooltip]="'Go to ' + assignment.mcpNumber"
              tooltipPosition="top"
            ></button>
          } @else {
            <span class="muted">—</span>
          }
        </td>
      }

      <!-- Tag -->
      @if (showColumn('tagNumber')) {
        <td class="col-tag">
          <div class="tag-cell">
            <span class="tag-number">{{ assignment.tagNumber || '-' }}</span>
            @if (isVoided(assignment)) {
              <p-tag value="VOIDED" severity="danger" styleClass="voided-badge"></p-tag>
            }
          </div>
          @if (assignment.tagName) {
            <div class="tag-name">{{ assignment.tagName }}</div>
          }
        </td>
      }

      <!-- Checksheet -->
      @if (showColumn('checksheetNumber')) {
        <td class="col-cs">
          <button
            pButton
            [label]="assignment.checksheetNumber || assignment.id"
            [text]="true"
            size="small"
            class="nav-btn"
            (click)="navToChecksheet(assignment)"
            [pTooltip]="'Open checksheet'"
            tooltipPosition="top"
          ></button>
        </td>
      }

      <!-- Type -->
      @if (showColumn('checksheetType')) {
        <td class="col-type">{{ assignment.checksheetType || '-' }}</td>
      }

      <!-- Status -->
      @if (showColumn('status')) {
        <td class="col-status">
          @if (assignment.status) {
            <app-status-circle [status]="getCompletionStatus(assignment.status)"></app-status-circle>
          } @else {
            <span class="muted">—</span>
          }
        </td>
      }

      <!-- Progress -->
      @if (showColumn('progress')) {
        <td class="col-progress">
          <div class="progress-cell">
            <p-progressBar [value]="progressPct(assignment)" [showValue]="false" styleClass="slim-bar"></p-progressBar>
            <span class="progress-label">{{ progressPct(assignment) }}%</span>
          </div>
        </td>
      }

      <!-- Punches -->
      @if (showColumn('punchCount')) {
        <td class="col-punch">
          @if (hasPunches(assignment)) {
            <div class="punch-info">
              <app-status-circle [status]="punchStatus(assignment)" [useSmall]="true"></app-status-circle>
              <span class="punch-count">{{ assignment.punchCount }}</span>
            </div>
          } @else {
            <span class="muted">—</span>
          }
        </td>
      }

      <!-- Signed -->
      @if (showColumn('signed')) {
        <td class="col-sig">
          @if (assignment.signed) {
            <div class="sig-cell signed" [pTooltip]="assignment.signedByTimestamp | date:'dd MMM yyyy HH:mm'" tooltipPosition="top">
              <span class="pi pi-check-circle sig-icon"></span>
              <span class="sig-name">{{ assignment.signedByUserName }}</span>
            </div>
          } @else {
            <span class="muted">—</span>
          }
        </td>
      }

      <!-- Verified -->
      @if (showColumn('verified')) {
        <td class="col-sig">
          @if (assignment.verified) {
            <div class="sig-cell verified" [pTooltip]="assignment.verifiedByTimestamp | date:'dd MMM yyyy HH:mm'" tooltipPosition="top">
              <span class="pi pi-verified sig-icon"></span>
              <span class="sig-name">{{ assignment.verifiedByUserName }}</span>
            </div>
          } @else {
            <span class="muted">—</span>
          }
        </td>
      }

      <!-- Site -->
      @if (showColumn('siteNumber')) {
        <td class="col-site">{{ assignment.siteNumber || '-' }}</td>
      }

      <!-- Company -->
      @if (showColumn('companyNumber')) {
        <td class="col-company">{{ assignment.companyNumber || '-' }}</td>
      }

      <!-- Phase -->
      @if (showColumn('phaseNumber')) {
        <td class="col-phase">{{ assignment.phaseNumber || '-' }}</td>
      }

      <!-- Missing -->
      @if (showColumn('missingCertificates')) {
        <td class="col-missing">{{ missingLabel(assignment) || '-' }}</td>
      }
    </tr>
  </ng-template>
</p-table>

